module.exports = __webpack_public_path__ + "static/media/zonifero_logo_black.ef52f150.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/zonifero_logo_black.svg
// module id = ./src/common/images/zonifero_logo_black.svg
// module chunks = 1